import useApiMutation from './useApiMutation';

function useLoginMutation(options) {
  return useApiMutation('post', '/v1/login', options);
}

export default useLoginMutation;
